import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ot_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response && error.response.status === 401) {
      const here = window.location.pathname;
      if (!here.startsWith("/login") && !here.startsWith("/register")) {
        localStorage.removeItem("ot_token");
        localStorage.removeItem("ot_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
